<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="360px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form
      ref="ruleForm"
      :model="info"
      :rules="rules"
      label-width="95px">
      <el-form-item
        label="分组名称："
        prop="groupName">
        <el-input v-model="info.groupName"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        {{ submitText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditGroupModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        groupId: null,
        groupName: ''
      },
      rules: {
        groupName: [
          { required: true, message: '请输入分组名称', trigger: 'blur' },
          { max: 15, message: '分组名称长度最多 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    title() {
      const trainingVideoId = this.info.trainingVideoId
      return (trainingVideoId ? '编辑' : '新增') + '视频分组'
    },
    submitText() {
      const trainingVideoId = this.info.trainingVideoId
      return trainingVideoId ? '更新' : '保存'
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.info = {
        groupId: null,
        groupName: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const dispatch = this.info.trainingVideoId
            ? 'updatetrainingvideogroup'
            : 'addtrainingvideogroup'
          this.$store.dispatch(`account/${dispatch}`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
              this.callback && this.callback()
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    },
    add() {
      this.toggleModal(true)
    },
    update(options = {}) {
      this.info = {
        ...this.info,
        ...options
      }
      this.toggleModal(true)
    }
  }
}
</script>
